import { Component, OnInit } from '@angular/core';
import {TimeZoneService} from "../../services/timezone.service";

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss']
})

export class CookiesComponent implements OnInit {

  // TimeZone
  public DefaultTimeZone:boolean = true;
  public USATimeZone:boolean = false;

  constructor(private timezoneService: TimeZoneService) {
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
  }

  ngOnInit() {
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
  }

}
